import { useMemo } from 'react';
import { getSubdomainContext, type SubdomainContext } from '../utils/subdomain';

export function useSubdomain(): SubdomainContext {
  return useMemo(() => getSubdomainContext(), []);
}

export function useIsSubdomain(): boolean {
  const context = useSubdomain();
  return context.isSubdomain;
}

export function useSubdomainUsername(): string | null {
  const context = useSubdomain();
  return context.username;
}
